import Modernisierung from '@/js/modernisierung';
import { gutachten } from '@/js/validation';
import productModule from '@/store/modules/produkt';

const defaultAllgemeineAngaben = () => {
  return {
    ermittlungsstichtag: undefined,
    baujahr: undefined,
    wohnungsnummer: undefined,
    anzahlWohneinheiten: undefined,
    anzahlNutzeinheiten: undefined,
    wohnflaeche: undefined,
    nutzflaeche: undefined,
    kernsanierung: false,
    jahrDerKernsanierung: undefined,
    valid() {
return gutachten.allgemeineAngaben({ ...this, objektart:productModule.getters.objektart() });
    },
  };
};

const allgemeineAngaben = defaultAllgemeineAngaben();

const defaultAussenwaende = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      aussenansichtVorne: undefined,
      aussenansichtHinten: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.aussenwaendeGutachten(
        { ...this },
        { ...allgemeineAngaben },
      );
    },
  };
};

const aussenwaende = defaultAussenwaende();

const defaultDach = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      dacheindeckungAussen: undefined,
      dachgeschossInnen: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.dachGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const dach = defaultDach();

const defaultFenster = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      hauseingangstuer: undefined,
      fenster: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.fensterGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const fenster = defaultFenster();

const defaultFussboeden = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      fussboden1: undefined,
      fussboden2: undefined,
      fussboden3: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.fussboedenGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const fussboeden = defaultFussboeden();

const defaultInnenwaende = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      innentuer1: undefined,
      innentuer2: undefined,
      innenwand1: undefined,
      innenwand2: undefined,
      innenwand3: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.innenwaendeGutachten(
        { ...this },
        { ...allgemeineAngaben },
      );
    },
  };
};

const innenwaende = defaultInnenwaende();

const defaultDecken = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      treppe1: undefined,
      treppe2: undefined,
      deckenkonstruktion1: undefined,
      deckenkonstruktion2: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.deckenGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const decken = defaultDecken();

const defaultSanitaer = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      bad1: undefined,
      bad2: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.sanitaerGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const sanitaer = defaultSanitaer();

const defaultHeizung = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      heizungsanlage1: undefined,
      heizungsanlage2: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.heizungGutachten({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const heizung = defaultHeizung();

const defaultTechnischeAusstattung = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    fotos: {
      sicherungskasten: undefined,
      steckdosen: undefined,
      offensichtlicheSchaeden: undefined,
      zusatzfoto: [],
    },
    valid() {
      return gutachten.technischeAusstattungGutachten(
        { ...this },
        { ...allgemeineAngaben },
      );
    },
  };
};

const technischeAusstattung = defaultTechnischeAusstattung();

const defaultObjektunterlagen = () => {
  return {
    grundriss: undefined,
    zusatzdokumentGrundriss: undefined,
    energieausweis: undefined,
    zusatzdokumentEnergieausweis: undefined,
    valid() {
      return gutachten.objektunterlagen({ ...this });
    },
  };
};

const objektunterlagen = defaultObjektunterlagen();

const defaultAnsprechpartner = () => {
  let vname = window.sessionStorage.getItem('vname');
  let nname = window.sessionStorage.getItem('nname');
  return {
    nachname: nname ? nname : undefined,
    vorname: vname ? vname : undefined,
    telefon: undefined,
    erlaeuterung: undefined,
    valid() {
      return gutachten.ansprechpartner({ ...this });
    },
  };
};

const ansprechpartner = defaultAnsprechpartner();

let ausSpeicherGeladen = false;

const defaultRechnungData = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    valid() {
      return gutachten.defaultRechnung({ ...this });
    },
  }
}

const defaultRechnung = defaultRechnungData();

const defaultAlternativeRechnung = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    useDefault: true,
    valid() {
      return gutachten.alternativeRechnung({ ...this });
    }
  }
}

const alternativeRechnung = defaultAlternativeRechnung();

export const defaultState = () => {
  Object.assign(allgemeineAngaben, defaultAllgemeineAngaben());
  Object.assign(aussenwaende, defaultAussenwaende());
  Object.assign(dach, defaultDach());
  Object.assign(fenster, defaultFenster());
  Object.assign(fussboeden, defaultFussboeden());
  Object.assign(innenwaende, defaultInnenwaende());
  Object.assign(decken, defaultDecken());
  Object.assign(sanitaer, defaultSanitaer());
  Object.assign(heizung, defaultHeizung());
  Object.assign(technischeAusstattung, defaultTechnischeAusstattung());
  Object.assign(objektunterlagen, defaultObjektunterlagen());
  Object.assign(ansprechpartner, defaultAnsprechpartner());
  Object.assign(defaultRechnung, defaultRechnungData());
  Object.assign(alternativeRechnung, defaultAlternativeRechnung());
  ausSpeicherGeladen = false;
  return {
    allgemeineAngaben,
    aussenwaende,
    dach,
    fenster,
    fussboeden,
    innenwaende,
    decken,
    sanitaer,
    heizung,
    technischeAusstattung,
    objektunterlagen,
    ansprechpartner,
    ausSpeicherGeladen,
    defaultRechnung,
    alternativeRechnung
  };
};
const state = defaultState();

export default state;
